module.exports = __webpack_public_path__ + "img/sch3-sub.6693da5e.png";